import {
  AfterContentInit,
  Component,
  ElementRef,
  OnInit,
  Renderer2,
  HostListener,
  ViewChild,
  HostBinding,
  Inject,
  ViewContainerRef,
  ChangeDetectorRef
} from "@angular/core";
import {StateService, any} from "@uirouter/angular";
import {DOCUMENT} from "@angular/platform-browser";
import {Cookie} from "ng2-cookies/ng2-cookies";
import '../assets/css/styles.css';
import '../assets/css/callsign.css';
import '../assets/css/desktop.css';
import WebAuthSdk, {TextInputFieldMetadata} from '@callsign/web-auth-sdk/index.js';
import {TransactionCompletedUnsuccessOptions} from "@callsign/web-auth-sdk";
import { v4 as uuidv4 } from 'uuid';
import { ErrorResponse, FormResponse, StatusResponse } from '@callsign/web-auth-sdk/index.js';
import "zone.js/dist/zone";
import {Http} from "@angular/http";
import "rxjs/add/operator/toPromise";
import {Subscription} from "rxjs";
const endpoint2 = 'https://eportal.life.hsbc.com.sg';
const emailRegEx = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,5}$/;
const passWordRegEx=/^[a-zA-Z0-9!\$*\-.=?@_\']*$/;
const invalidcharRegex=/^[^$%!#?*]+$/;
const smsRegEx =/^[0-9]*$/;

declare var window: any;
@Component({
  selector: 'digital-security-platform-web',
  template: require('./app.component.html')
})

export class AppComponent {
  title = 'my-app';
  countLogonScreen = 0;
  countPasswordScreen = 0;
  countSmsScreen=0;
  passwordScreen = null;  //to replicate password error journey
  lastScreenWasPasswordScreen = false;  //to replicate password error journey
  screenTypeContainer: any;
  isNotificationDisplayed: boolean = true;
  isValidationError: boolean = false;
  clsHelpClicked: boolean = false;
  isHelpExp = false;
  currentHelpSection = '';
  helpTimer: boolean = false;
  showHideUser: boolean = false;
  loginFirstName: string;
  loginMaskedUserName: string;
  isServerError: boolean = false;
  userAuthResponse: any;
  contextResponse : any;
  mobileNumber: any;
  otpTimestamp: any;
  passwordContainer: boolean=false;
  smsOTPContainer: boolean=false;
  public sdk: WebAuthSdk | null=null;
  //LoginOTP
  clientId:string= "cli-tqgph3qd-7jp7gp9d-hmxc6hy17-ezn2ce29";
  //Login
  //clientId:string= "cli-85g0ngrc-pcrrsa4f-ntvfff4qt-59kawb04";
  redirectUrl:string = "https://eportal.life.hsbc.com.sg/security";
  @ViewChild('HELP_CLOSE', {read: ElementRef}) HELP_CLOSE: ElementRef;
  @ViewChild('HELPLINK', {read: ElementRef}) HELPLINK: ElementRef;
  @ViewChild('HELP_OVERLAY', {read: ElementRef}) HELP_OVERLAY: ElementRef;
  @ViewChild('HEADER_COL', { read: ElementRef }) HEADER_COL: ElementRef;
  @ViewChild('HEADER_EXP', { read: ElementRef }) HEADER_EXP: ElementRef;

  @HostListener('document:click', ['$event'])
  onClick(e) {
    let target = (e && e.target) || (event && event.srcElement),
      switchUser_Col = this.elementSelf.nativeElement.querySelector('#id_switchUser_Col'), //document.getElementById("id_switchUser_Col");//Menu
      switchUser_Exp = this.elementSelf.nativeElement.querySelector('#id_switchUser_Exp'); //document.getElementById("id_switchUser_Exp");//Menu Div

    if (!this.checkParent(target, switchUser_Exp)) {
      if (!this.checkParent(target, switchUser_Col)) {
        if (this.showHideUser) {
          this.changeShowStatus(true);
          this.changedetector.detectChanges();
        }
      }
    }

  }

  constructor(
    private elementSelf: ElementRef,private changedetector:ChangeDetectorRef
  ) {
    var meta = document.createElement('meta');
    meta.httpEquiv = "X-UA-Compatible";
    meta.content = "IE=edge";
    document.getElementsByTagName('head')[0].appendChild(meta);
    var meta2 = document.createElement('meta');
    meta2.name = "viewport";
    meta2.content = "width=device-width, initial-scale=1";
    document.getElementsByTagName('head')[0].appendChild(meta);
    document.getElementsByTagName('head')[0].appendChild(meta2);
    var link = document.createElement('link');
    link.rel = "icon";
    link.type = "image/x-icon";
    link.href = "/etc/designs/dpws/common/favicons/favicon.ico";
    document.getElementsByTagName('head')[0].appendChild(link);
    //Check if dspSessionDup cookie exists , redirect the user to loginchoice for multitab scenario
    if (document.cookie.split(';').some(function(item) {
      return item.trim().indexOf('dspSessionDup=') == 0
    })) {
      document.location.href = '/loginchoice';
    }else{
      console.log("dspSessionDup cookie does not exists");
    }
    this.initAuthentication();
  }

  private startWebAuthSdk() : Promise<void> {
    this.sdk = new WebAuthSdk({
      baseUrl: endpoint2,
      modal: false,
      container: '#app-container',
      enableIntelligence: true,
      transactionTimeout:150,
      initialScreenTimeout: 210,
      //method to be called on error page action button, options retry | cancel
      errorBehavior: 'cancel',
      style: {
        logoImageUrl: "text for logo",
        loadingImageUrl: '../assets/images/ajax-loader.gif',
        successImageUrl:null
      },
      retryButton: {
        visible: false,
      },
      cancelButton: {
        visible: false
      },
      dateInputType: 'custom',
      missingTemplateText: 'expose',
      supportInformation: {               // Override default support information
        text: '',
        url: ''
      },
    });

    this.sdk.onTransactionCompleted = async (success, options): Promise<void> => {
      this.countPasswordScreen=0;
      this.countLogonScreen=0;
      if (success) {
        // @ts-ignore
        this.sdk.clear();
        await this.initAuthentication(true);
        document.location.href = '/authenticated';
      } else {
        if ((options as TransactionCompletedUnsuccessOptions).cause === 'user-cancel'){
         await this.initAuthentication();
        }
      }
    };

    this.sdk.onCanceling=()=>{
      console.log("oncancelling event");
    }

    this.sdk.onPageRendering = (message: FormResponse | StatusResponse | ErrorResponse): FormResponse | StatusResponse | ErrorResponse => {
      console.log("onpage rendering+++++");
      switch (message.screenType) {
        case 'ERROR':
          document.title = "Service Unavailable | Security | HSBC Life";
          const errorScreen = message as ErrorResponse;
          errorScreen.headerTemplateRef = '#[error_header]';
          errorScreen.reference="";
          errorScreen.defaultActionLabel='#[error_action_button]';
          errorScreen.defaultActionLabel="Return to homepage";
          console.log("error context responselock",this.contextResponse);
          const currentTimeStamp=new Date().getTime();
          console.log("current ts",currentTimeStamp);
          console.log("otp ts",this.otpTimestamp);
          this.otpTimestamp= this.otpTimestamp*1000;
          if(errorScreen.messages[0] == "Password is Locked"){
            document.title = "Password locked | Log on | HSBC Life";
            console.log("error context responselock",errorScreen);
            errorScreen.name = "Passwordlocked";
            errorScreen.messages[0] = '#[errorBody_Template_password_lock]';
            errorScreen.defaultActionInProgressLabel='#[continue_button_loader]';
            errorScreen.defaultActionLabel="Reset password";
          }else if (errorScreen.messages[0] == "User is Suspended"){
            document.title = "User Deactivated | Log on | HSBC Life";
            errorScreen.name = "UserSuspended";
            errorScreen.messages[0] = '#[errorBody_Template_user_suspended]';
            errorScreen.defaultActionLabel="Return to homepage";
          }else if (errorScreen.messages[0] == "User in Sanction Country"){
            document.title = "Sanction Country| Log on | HSBC Life";
            errorScreen.name = "SanctionCountry";
            errorScreen.messages[0] = '#[errorBody_Template_sanctioned_country]';
            errorScreen.defaultActionLabel="Return to homepage";
          }else if (errorScreen.messages[0] == "The approval request has expired. Please try again." || errorScreen.name=="transactionTimeoutError" || errorScreen.name=="networkError" || errorScreen.name=="internalError"){
            document.title = "Session timeout | Security | HSBC Life";
            errorScreen.name = "Sessiontimeout";
            errorScreen.messages[0] = '#[errorBody_Template_session_timeout]';
            errorScreen.defaultActionLabel="Return to homepage";
            errorScreen.defaultActionInProgressLabel='#[continue_button_loader]';
            //CLOSE HELP
            this.clsHelpClicked = false;
            this.currentHelpSection = "";
            this.changedetector.detectChanges();
          }else if(errorScreen.messages[0] == "#[errorBody_Template_too_many_pin_codes_requested]"){
            document.title = "Too many verification code requested | Security | HSBC Life\n";
            errorScreen.name = "TooManyCodesRequested";
            errorScreen.messages[0] = '#[errorBody_Template_too_many_pin_codes_requested]';
          }else if(this.otpTimestamp && (currentTimeStamp < this.otpTimestamp) && errorScreen.messages[0] == "The approval request has failed. Please try again."){
            document.title = "Too many verification code requested | Security | HSBC Life\n";
            errorScreen.name = "TooManyCodesRequested";
            errorScreen.messages[0] = '#[errorBody_Template_too_many_pin_codes_requested]';
          }else {
            console.log("lock",errorScreen);
            console.log("lock",errorScreen.messages[0]);
            document.title = "Service Unavailable | Security | HSBC Life";
            errorScreen.name = "ServiceUnavailable";
            errorScreen.messages[0] = '#[errorBody_Template_generic_error]';
            errorScreen.defaultActionLabel="Return to homepage";
          }
          errorScreen.defaultActionInProgressLabel='#[continue_button_loader]';
          break;

        case 'FORM':
          const formScreen = message as FormResponse;
          //Username Form
          if(formScreen.form.inputs[0].id === 'username') {
            this.countLogonScreen++;
            document.title = "Username | Log on | HSBC Life";
            formScreen.headerTemplateRef = '#[username_header]';
            formScreen.defaultActionLabel="Continue";
            formScreen.form.inputs[0].label='#[username_label]';
            formScreen.defaultActionInProgressLabel='#[continue_button_loader]';
            if (formScreen.form.rememberMe) {
              formScreen.form.rememberMe.available = false;
            }
            (formScreen.form.inputs[0] as TextInputFieldMetadata).maxLength=80;
            this.contextResponse = this.sdk.getCurrentContextData('exchange_message');
            if(this.contextResponse !=undefined && this.contextResponse.errorcode=="username_failure_002"){
              this.isServerError = true;
              this.changedetector.detectChanges();
              formScreen.bodyStartTemplateRef='#[username_error]';
              formScreen.form.inputs[0].value = sessionStorage.getItem('loginUsername');
              } else if(this.countLogonScreen>1){
              this.isServerError = true;
              this.changedetector.detectChanges();
              formScreen.bodyStartTemplateRef='#[username_error]';
              formScreen.form.inputs[0].value = sessionStorage.getItem('loginUsername');
            }

            //inline error validation
            this.sdk.handleValidation('username',
              (value, formMessage) => {
                if(value.length==0) {
                  this.isValidationError=true;
                  this.isServerError = false;
                  this.changedetector.detectChanges();
                  return {errorMessage: 'Please provide your registered email address'};
                }
                if(!invalidcharRegex.test(value)){
                  this.isValidationError=true;
                  this.isServerError = false;
                  this.changedetector.detectChanges();
                  return { errorMessage: 'You have entered an invalid character. Please remove the character before continuing.' };
                }
                if (!emailRegEx.test(value)){
                  this.isValidationError=true;
                  this.isServerError = false;
                  this.changedetector.detectChanges();
                  return { errorMessage: 'Please enter a valid email address.' };
                }
                if(value.length>0 && value.length<5) {
                  this.isValidationError=true;
                  this.isServerError = false;
                  this.changedetector.detectChanges();
                  return {errorMessage: 'Your username is not complete.' };
                }
                return null;
              });
          }

          //Password form
          if(formScreen.name === 'passwordForm'){
            this.passwordContainer= true;
            this.countPasswordScreen++;
            document.title = "Password | Log on | HSBC Life";
            formScreen.form.inputs[0].label='#[password_label]';
            formScreen.footerTemplateRef='#[password_footer]';
            formScreen.defaultActionInProgressLabel='#[continue_button_loader]';
            (formScreen.form.inputs[0] as TextInputFieldMetadata).maxLength=30;
            if(this.countPasswordScreen==1) {
              this.userAuthResponse = {
                isOlrSetup: this.sdk.getCurrentContextData("exchange_isOlrSetup"),
                passwordAuthAllowed: this.sdk.getCurrentContextData("exchange_passwordAuthAllowed"),
                isOlrLocked: this.sdk.getCurrentContextData("exchange_isOlrLocked"),
                username: this.sdk.getCurrentContextData("username"),
              };
              sessionStorage.setItem('userAuthResponse',JSON.stringify(this.userAuthResponse));
            }
            console.log('password contxt data',this.contextResponse);
            this.loginFirstName=this.getCurrentTime();
            this.changedetector.detectChanges();
            let uname=sessionStorage.getItem('loginUsername');
            this.loginMaskedUserName=this.getMaskedUsername(uname);
            formScreen.defaultActionLabel="Log On";
            formScreen.headerTemplateRef='#[password_header]';
            this.contextResponse = this.sdk.getCurrentContextData("exchange_message");
            if(this.countPasswordScreen > 1 && !(this.contextResponse!=undefined && this.contextResponse.errorcode=="password_failure_002") && !(this.contextResponse!=undefined && this.contextResponse.errorcode=="password_failure_003" || this.contextResponse=="Password Locked")){
              message = {
                "screenType": "ERROR",
                "name": "ServiceUnavailable",
                "messages": ['#[errorBody_Template_generic_error]'],
                'headerTemplateRef': '#[error_header]',
                "defaultActionLabel": "Return to homepage"
              }
              document.title = "Service Unavailable | Security | HSBC Life";
              return message;
            }
            if(this.sdk.getCurrentContextData("exchange_message")!=undefined && this.contextResponse.errorcode=="password_failure_002"){
              this.isServerError = true;
              formScreen.bodyStartTemplateRef='#[password_error]';
              this.changedetector.detectChanges();
            }
            console.log("lock",this.contextResponse);
            if(this.contextResponse!=undefined && (this.contextResponse.errorcode=="password_failure_003" || this.contextResponse=="Password Locked")){
              message = {
                "screenType":"ERROR",
                "name": "Passwordlocked",
                "messages":['#[errorBody_Template_password_lock]'],
                'headerTemplateRef' : '#[error_header]',
                'defaultActionLabel' : 'Reset password',
                'defaultActionInProgressLabel' : '#[continue_button_loader]'
              }
              return message;
            }

            this.sdk.handleValidation('password',
              (value, formMessage) => {
                if(value.length==0) {
                  this.isValidationError=true;
                  this.isServerError = false;
                  this.changedetector.detectChanges();
                  return {errorMessage: 'You must provide your password'};
                }
                if (!passWordRegEx.test(value)){
                  this.isValidationError=true;
                  this.isServerError = false;
                  this.changedetector.detectChanges();
                  return { errorMessage: 'You have entered an invalid character. Please remove the character before continuing.\n' };
                }
                if(value.length>0 && value.length<8) {
                  this.isValidationError=true;
                  this.isServerError = false;
                  this.changedetector.detectChanges();
                  return {errorMessage: 'Your password is a minimum of 8 characters long.' };
                }
                return null;
              });

              this.otpTimestamp = this.sdk.getCurrentContextData("timestampType");


          }

          //Already Password locked scenario
          if(formScreen.name === 'miForm'){
            document.title = "Password locked | Log on | HSBC Life";
            this.userAuthResponse = {
              isOlrSetup : this.sdk.getCurrentContextData("exchange_isOlrSetup"),
              passwordAuthAllowed: this.sdk.getCurrentContextData("exchange_passwordAuthAllowed"),
              isOlrLocked: this.sdk.getCurrentContextData("exchange_isOlrLocked"),
              username: this.sdk.getCurrentContextData("username"),
            };

            sessionStorage.setItem('userAuthResponse',JSON.stringify(this.userAuthResponse));
            const passwordLockedForm: FormResponse = {
              screenType: 'FORM',
              headerTemplateRef: '#[error_header]',
              bodyStartTemplateRef: '#[errorBody_Template_password_lock]',
              form: {
                inputs: [],
                metadata: (this.sdk.getCurrentScreen() as FormResponse).form.metadata
              },
              defaultActionLabel: 'Reset password',
              defaultActionInProgressLabel:'#[continue_button_loader]',
            };

            return passwordLockedForm;
          }

          //Enter SMS otp screen
          if(formScreen.name == 'otpForm'){
            document.title = "SMS verification | Security | HSBC Life";
            this.smsOTPContainer=true;
            this.passwordContainer= false;
            (formScreen.form.inputs[0] as TextInputFieldMetadata).maxLength=6;
            this.screenTypeContainer='SMS';
            formScreen.headerTemplateRef = '#[sms_header]';
            formScreen.bodyStartTemplateRef ='#[sms_body]';
            formScreen.form.inputs[0].label='#[sms_label]';
            formScreen.defaultActionInProgressLabel='#[continue_button_loader]';
            var errorResponse= this.sdk.getCurrentContextData("errors");
            console.log('invalid error',errorResponse);
            this.mobileNumber = this.sdk.getCurrentContextData("mask_phoneNumber");
            this.otpTimestamp = this.sdk.getCurrentContextData("timestampType");
            if(this.sdk.getCurrentContextData("otpExpired")){
              const otpExpiredScreen: FormResponse = {
                screenType: 'FORM',
                name: 'otpExpired',
                headerTemplateRef: '#[error_header]',
                bodyStartTemplateRef: '#[errorBody_Template_sms_code_expired]',
                form: {
                  inputs: [],
                  metadata: (this.sdk.getCurrentScreen() as FormResponse).form.metadata
                },
                defaultActionLabel: 'Request new verification code',
                defaultActionInProgressLabel:'#[continue_button_loader]',
                actionsStartTemplateRef:'#[errorTemplate_secondary_button]',
              };

              return otpExpiredScreen;
            }
            if(this.sdk.getCurrentContextData("maxFailureReached")){
              const maxFailureReached: FormResponse = {
                screenType: 'FORM',
                name: 'maxFailureReached',
                headerTemplateRef: '#[error_header]',
                bodyStartTemplateRef: '#[errorBody_Template_request_new_code]',
                form: {
                  inputs: [],
                  metadata: (this.sdk.getCurrentScreen() as FormResponse).form.metadata
                },
                defaultActionLabel: 'Request new verification code\n',
                defaultActionInProgressLabel:'#[continue_button_loader]',
                actionsStartTemplateRef:'#[errorTemplate_secondary_button]',
              };
              document.title = "Request new activation code | Security | HSBC Life";
              return maxFailureReached;
            }
            if (formScreen.form.errors[0]=="OTP invalid. Please retry.") {​​​​​
              this.isServerError = true;
              this.isValidationError=false;
              formScreen.form.inputs[0].errors = ['#[sms_error]'];
              formScreen.form.errors=[];
              this.changedetector.detectChanges();
            }​​​​​
            formScreen.defaultActionLabel="Continue";
            formScreen.form.inputs[0].label='#[sms_label]';
            formScreen.footerTemplateRef='#[sms_footer]';

            this.sdk.handleValidation('otp',
              (value, formMessage) => {
                if(value.length==0) {
                  this.isValidationError=true;
                  this.isServerError = false;
                  this.changedetector.detectChanges();
                  return {errorMessage: 'You must provide your verification code.'};
                }
                if (!smsRegEx.test(value)){
                  this.isValidationError=true;
                  this.isServerError = false;
                  this.changedetector.detectChanges();
                  return { errorMessage: 'You have entered an invalid character. Please remove the character before continuing.' };
                }
                if(value.length>0 && value.length<6) {
                  this.isValidationError=true;
                  this.isServerError = false;
                  this.changedetector.detectChanges();
                  return {errorMessage: 'Your verification code must be 6 digits long.' };
                }
                return null;
              });
          }

          break;
        case 'STATUS':
          const statusScreen = message as StatusResponse;
          break;
      }

      window.setTimeout(() => {
        const image = document.querySelector('#helpImage');
      }, 1000);
      return message;
    };

    this.sdk.onSendingData = function(data, formScreen) {
      if(formScreen.form.inputs[0].id === 'username') {
        sessionStorage.setItem('loginUsername', (data as any).username);
      }
    }



    this.sdk.onPageRendered=(message: FormResponse | StatusResponse | ErrorResponse): void => {
      //Handle action of primary buttons
      if (message.name == "Passwordlocked" || (message.bodyStartTemplateRef != undefined && message.bodyStartTemplateRef == '#[errorBody_Template_password_lock]')) {
        this.sdk.overrideDefaultActionHandler(e=>{
          document.location.href = '/security/resetChoice/';
        });
      }else if(message.name == "UserSuspended" || message.name == "SanctionCountry" || message.name == "Sessiontimeout" || message.name == "ServiceUnavailable"){
        console.log("timeout msg",message);
        this.sdk.overrideDefaultActionHandler(e=>{
          document.location.href = '/loginchoice';
        });
      }else if(message.name == "otpExpired"){
        this.sdk.overrideDefaultActionHandler(e=>{
          this.sdk.submitForm({formType:"OTP_AUTH", generate_new_otp:"true"});
        });
      }else if(message.name == "maxFailureReached"){
        this.sdk.overrideDefaultActionHandler(e=>{
          this.sdk.submitForm({formType:"OTP_AUTH", generate_new_otp:"true"});
        });
      }
      this.changedetector.detectChanges();
    }

    return this.sdk.start();

  }



  public helpClick(helpContent): void {
    console.log('Help on the way');
    let thisObj = this;
    if (this.helpTimer) {
      return;
    }
    if (!this.isHelpExp && this.currentHelpSection == "") {
      thisObj.clsHelpClicked = true;
      this.currentHelpSection = helpContent;
      this.isHelpExp = !this.isHelpExp
    }
    else {
      if (this.isHelpExp && this.currentHelpSection != helpContent) {
        thisObj.clsHelpClicked = true;
        this.isHelpExp = !this.isHelpExp; // False === Collapse Old
        this.helpTimer = true;
        setTimeout(function () {
          thisObj.helpTimer = false;
          thisObj.clsHelpClicked = true;
          thisObj.isHelpExp = !thisObj.isHelpExp; //True == Expand New
          thisObj.currentHelpSection = helpContent;
        }, 900);
      }
      else {
        if (!this.isHelpExp && this.currentHelpSection != "") {
          this.clsHelpClicked = true;
          this.currentHelpSection = helpContent;
        } else {
          this.clsHelpClicked = false;
          this.currentHelpSection = "";
        }
        this.isHelpExp = !this.isHelpExp;
      }
    }
    let tm = 1000;
    if (this.helpTimer) {
      tm = 2100;
    }
    setTimeout(function () {
      let h2Ele = thisObj.elementSelf.nativeElement.querySelector('#help_content');
      if (h2Ele.scrollHeight > h2Ele.clientHeight) {
        h2Ele.setAttribute('tabIndex', '0');
      } else { h2Ele.removeAttribute('tabIndex'); }
      if (thisObj.clsHelpClicked) {
        thisObj.HELP_CLOSE.nativeElement.focus();
      } else {
        if (thisObj.HELPLINK) {
          thisObj.HELPLINK.nativeElement.focus();
        }
      }
    }, tm);
    sessionStorage.setItem('isHelpExp', this.isHelpExp ? 'yes' : 'no');
    this.changedetector.detectChanges();
  }

  public blurSwitchUser(e, isShiftKey): void {
    if (e.shiftKey == isShiftKey && e.keyCode == 9) {
      let x = !isShiftKey;
      this.changeShowStatus(x);
    }
  }

  backToLogon() {
    console.log("switching user");
    this.sdk.cancel();
    //CLOSE HELP
    this.clsHelpClicked = false;
    this.currentHelpSection = "";
  }

  changeShowStatus(isDefaultBehavior) {
    window.isSwitchUser = true;
    let thisObj = this;
    this.showHideUser = !this.showHideUser;
    if (this.showHideUser) {
      setTimeout(function () {
        if (!isDefaultBehavior) {
          thisObj.HEADER_EXP.nativeElement.focus();
        }
      }, 100);
    } else {
      if (!isDefaultBehavior) {
        this.HEADER_COL.nativeElement.focus();
      }
    }
    this.changedetector.detectChanges();
  }

  checkParent(t, elm) {
    while (t.parentNode) {
      if (t == elm) {
        return true;
      }
      t = t.parentNode;
    }
    return false;
  }

  getCurrentTime(): string {
    let myDate = new Date();
    let hrs = myDate.getHours();
    var userName;
    if (hrs < 12)
      userName = "Good morning";
    else if (hrs >= 12 && hrs <= 17)
      userName = "Good afternoon";
    else if (hrs >= 17 && hrs <= 24)
      userName = "Good evening";
    return userName;
  }

  getMaskedUsername(uname): string {
    let maskedUsername: string = '';
    let arrEmail= uname.split('@');
    let domain = '@' + arrEmail[1];
    let id = arrEmail[0];
    maskedUsername = id.substr(id.length-4);
    maskedUsername = maskedUsername + domain;
    for (let i = 0; i < id.length - 4; i++) {
      maskedUsername = '*' + maskedUsername;
    }
    return maskedUsername;
  }

  cam10BannerClose(){
    this.isNotificationDisplayed=false;
    this.changedetector.detectChanges();
  }

  public notReceivedCodelinkClicked():void{
    console.log("start notreceivedlink");
    const requestNewCodePage: FormResponse = {
      screenType: 'FORM',
      headerTemplateRef: '#[error_header]',
      bodyStartTemplateRef: '#[errorBody_Template_verification_code_not_received]',
      name:'verificationCodeNotReceived',
      form: {
        inputs: [],
        metadata: (this.sdk.getCurrentScreen() as FormResponse).form.metadata
      },
      defaultActionLabel: 'Request new verification code',
      defaultActionInProgressLabel: '#[continue_button_loader]',
    };
    document.title = "Verification code not received";
    //this.sdk.renderLocalPage(requestNewCodePage,() => this.sdk.submitForm({formType:"OTP_AUTH", generate_new_otp:"true"}));
    this.sdk.renderLocalPage(requestNewCodePage, () => {
      this.sdk.submitForm({formType: "OTP_AUTH", generate_new_otp: "true"});
    });
  }

  private async initAuthentication(resumeOIdC: boolean = false): Promise<void>{
     await this.processOIdCFlow();
     if (!resumeOIdC) {
       return await this.startWebAuthSdk();
     }
     return Promise.resolve();
  }

  private async processOIdCFlow(): Promise<void> {
    try {
      const response = await fetch(
        endpoint2 + `/po/portal/v1/sso/oauth/authorize?client_id=${this.clientId}&response_type=code&scope=openid%20user_info&response_mode=query&redirect_uri=${encodeURIComponent(this.redirectUrl)}`,
        {
          credentials: 'include',
          redirect: 'manual'
        });

      if (response.type !== 'opaqueredirect') {
        throw new Error(response.status.toString() + ' ' + response.statusText);
      }

    } catch (e) {
      console.log('error: ', e);
    }
  }

}



